module.exports = __webpack_public_path__ + "static/body-3ff496d2b5e3bfe0936fe69226c23ee1.png";